/**
 * Alder i hele år fra en fødselsdato `YYYY-MM-DD` (#159, steg 9a).
 *
 * Barnekortet på Familie viser «Mia · 11 år». Regnes på datodelene i lokal tid,
 * ikke som millisekunder delt på 365,25 dager, så alderen skifter på selve
 * bursdagen og ikke en dag før eller etter. `null` for en dato som ikke kan
 * leses, eller som ligger fram i tid.
 */
export function ageInYears(birthDate: string, now: Date): number | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(birthDate);
  if (!m) return null;
  const year = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  const nowMonth = now.getMonth() + 1;
  const beforeBirthday = nowMonth < month || (nowMonth === month && now.getDate() < day);
  const age = now.getFullYear() - year - (beforeBirthday ? 1 : 0);
  return age >= 0 ? age : null;
}
